import { Injector } from "@angular/core";
import { MeddraService } from "../../../../service/meddra-service/meddra.service";
import { MeddraNode, HierarchyMode } from "../MeddraNode";
import { TreeNodeMeddraLevelItem } from "./TreeNodeMeddraLevelItem";
import { HLGTListView } from "../../../Data/MeddraData/HLGTListView";
import { environment } from "../../../../../../environments/environment";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { SOCListView } from "../../../Data/MeddraData/SOCListView";
import { FieldDefinition } from "../../../../../sections/meddra/message/fieldDefinition";
import { MeddraTerm } from "../../../Data/MeddraData/MeddraTerm";
import { DummyNode } from "../../DummyNode";
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";


export class TreeNodeHLGTItem extends TreeNodeMeddraLevelItem {

    constructor(injector: Injector, data: any, parent: BaseNode) {
        super(injector, data, EntityEnum.hlgt, injector.get(Art57Section).meddra.hlgtTermsTreeNode, parent);
        this.children?.push(new DummyNode());
    }

    override createChildren(): void {

        //Retrieve "High Level Terms for this HLG term"
        let hltNode = new MeddraNode(this.ioc!, new HLGTListView([]), `High Level Terms ({param})`, EntityEnum.hlt,this.ioc!.get(Art57Section).meddra.hltTermsTreeNode, this, HierarchyMode.DESCENDING)
        this.children!.push(hltNode);
        this.ioc!.get(MeddraService).getAll(this,EntityEnum.hlt, `hlgt_code:eq:${this.data.model.code}`).subscribe(
            {
                next: (data:any) => {
                    hltNode.data = new HLGTListView(data.result);
                    data.result.forEach((i: any) => hltNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).hltFields, i), i.name, EntityEnum.hlt, this.ioc!.get(Art57Section).meddra.hltTermsTreeNode, hltNode, HierarchyMode.DESCENDING)))
                    hltNode.refreshLabel();
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });

        //Retrieve "SOC term for this HLG term"
        let socNode = new MeddraNode(this.ioc!, new SOCListView([]), `System Organ class ({param})`, EntityEnum.soc, null, this, HierarchyMode.ASCENDING);
        this.children!.push(socNode);
        this.ioc?.get(MeddraService).getAll(this,EntityEnum.soc, `hlgt_code:eq:${this.data.model.code}`).subscribe(
            {
                next: (data:any) => {
                    socNode.data = new SOCListView(data.result);
                    data.result.forEach((i: any) => socNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).socFields, i), i.name, EntityEnum.soc, this.ioc!.get(Art57Section).meddra.socTermsTreeNode, socNode, HierarchyMode.ASCENDING)))
                    socNode.refreshLabel();
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });
    }


}